import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "narrow-text" }
const _hoisted_3 = { class: "lg:text-center" }

import ArticleModalContent from '@/components/ArticleModalContent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Protetika',
  emits: ["close", "navigate"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_circular_image = _resolveComponent("a-circular-image")!
  const _component_a_info_panel = _resolveComponent("a-info-panel")!

  return (_openBlock(), _createBlock(ArticleModalContent, {
    title: _ctx.$t('articles.protetika.title'),
    cover: require('@/assets/covers/protetika.jpg'),
    "close-button-dark": true,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/mosticek.jpg'),
          class: "sm:!hidden"
        }, null, 8, ["image"]),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.protetika.mosticekTitle')), 1),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/mosticek.jpg'),
          class: "!hidden sm:!block"
        }, null, 8, ["image"]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.protetika.mosticekP1')), 1),
        _createVNode(_component_a_info_panel, {
          icon: require('@/assets/png-icons/bulb.png'),
          class: "mb-rem2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.protetika.mosticekInfoBold')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.protetika.mosticekInfoBody')), 1)
          ]),
          _: 1
        }, 8, ["icon"]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.protetika.mosticekP2pre')), 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.protetika.mosticekReplace')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.protetika.mosticekP2post')), 1)
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/prevleka.jpg'),
          float: "left",
          class: "!hidden sm:!block"
        }, null, 8, ["image"]),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.protetika.prevlekeTitle')), 1),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/prevleka.jpg'),
          class: "sm:!hidden"
        }, null, 8, ["image"]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.protetika.prevlekeP1pre')), 1),
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', 'endodontsko')))
          }, _toDisplayString(_ctx.$t('articles.protetika.prevlekeEndo')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.protetika.prevlekeP1post')), 1)
        ]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.protetika.prevlekeP2pre')), 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.protetika.prevlekeMetalCeramic')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.protetika.prevlekeP2mid1')), 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.protetika.prevlekeFullCeramic')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.protetika.prevlekeP2mid2')), 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.protetika.prevlekeZirconia')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.protetika.prevlekeP2post')), 1)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.protetika.luskeTitle')), 1),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/luska.jpg'),
          class: "!hidden sm:!block"
        }, null, 8, ["image"]),
        _createVNode(_component_a_info_panel, {
          icon: require('@/assets/png-icons/bulb.png'),
          class: "mb-rem2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.protetika.luskeInfoBold')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.protetika.luskeInfoBody')), 1)
          ]),
          _: 1
        }, 8, ["icon"]),
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/luska.jpg'),
          class: "sm:!hidden"
        }, null, 8, ["image"]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.protetika.luskeP1')), 1),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.protetika.luskeP2pre')), 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.protetika.luskeZirconia')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.protetika.luskeP2post')), 1)
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.protetika.luskeP3')), 1),
        _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.protetika.materialiTitle')), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.protetika.materialiIntro')), 1),
          _createElementVNode("p", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.protetika.materialiMetalCeramicBold')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.protetika.materialiMetalCeramicBody')), 1)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.protetika.materialiFullCeramicBold')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.protetika.materialiFullCeramicBody')), 1)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.protetika.materialiZirconiaBold')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.protetika.materialiZirconiaBody')), 1)
          ])
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t('articles.protetika.cenikPre')), 1),
        _createElementVNode("b", {
          class: "internal-link",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('navigate', 'cenik', 'fiksna-protetika')))
        }, _toDisplayString(_ctx.$t('articles.protetika.cenikLinkText')), 1),
        _createTextVNode(_toDisplayString(_ctx.$t('articles.protetika.cenikPost')), 1)
      ])
    ]),
    _: 1
  }, 8, ["title", "cover"]))
}
}

})